import { ReactNode } from 'react';

import { Grid, GridItem } from 'components/Grid';
import { CmsApiBlockType } from 'modules/cms/api/types/CmsApiBlock';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';

type Props = {
  withSidebar: boolean;
  fullWidthLayout: boolean;
  blockType: CmsApiBlockType;
  blockWidth: CmsBlockWidth | undefined;
  children: ReactNode;
};

export function CmsBlockContainerGrid({
  withSidebar,
  fullWidthLayout,
  blockType,
  blockWidth,
  children,
}: Props) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (withSidebar) return <>{children}</>;

  switch (blockWidth) {
    case CmsBlockWidth.NARROW:
    case CmsBlockWidth.INSET:
    case CmsBlockWidth.GRID:
      if (fullWidthLayout || blockType === 'SPLIT_CONTENT') {
        return (
          <Grid>
            <GridItem columnStart={[1, 1, 1, 1]} columnEnd={[13, 13, 13, 13]}>
              {children}
            </GridItem>
          </Grid>
        );
      }

      return (
        <Grid>
          <GridItem columnStart={[1, 1, 1, 2]} columnEnd={[13, 13, 13, 12]}>
            {children}
          </GridItem>
        </Grid>
      );

    case 'FULL':
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{children}</>;
  }
}
